import { render, staticRenderFns } from "./BatchesReport.vue?vue&type=template&id=186e8f83&scoped=true&"
import script from "./BatchesReport.vue?vue&type=script&lang=js&"
export * from "./BatchesReport.vue?vue&type=script&lang=js&"
import style0 from "./BatchesReport.vue?vue&type=style&index=0&id=186e8f83&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "186e8f83",
  null
  
)

export default component.exports